import React from "react";
import TableSelector from "../../../components/tables/TableSelector";
import spqr30 from "../../../components/tables/onv-pass-30";
import spqr43 from "../../../components/tables/onv-pass-43";
import spqr44 from "../../../components/tables/onv-pass";

const data = [
  {
    les: "30",
    table: spqr30
  },
  {
    les: "43",
    table: spqr43
  },
  {
    les: "44",
    table: spqr44
  }
];

export default () => (
  <TableSelector defaultChapter="44" data={data} title="Onvoltooid passief" />
);



// WEBPACK FOOTER //
// ./src/pages/spqr/rijtjes/onvoltooid-passief.js